module.exports = {
      id: "logout-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#logout-usage",
      toString: function () {
        return this.url;
      }
    }